import React from "react";
import RegisterContext, { useRegisterStateValue } from "./RegisterContext";
import RegisterContent from "./register-content/RegisterContent";

const RegisterContainer = () => {
    return (
        <RegisterContext>
            <RegisterContent />
        </RegisterContext>
    );
};

export default RegisterContainer;
